import { Link } from "react-router-dom";
import { LOGO_URL } from "@/lib/api";

const Col = ({ title, children }) => (
  <div>
    <p className="text-[11px] uppercase tracking-wider text-on-dark-muted mb-4">{title}</p>
    <ul className="space-y-2.5">{children}</ul>
  </div>
);

const FLink = ({ to, children }) => (
  <li>
    <Link to={to} className="text-sm text-on-dark hover:text-lovac-accent transition-colors">
      {children}
    </Link>
  </li>
);

export default function Footer() {
  return (
    <footer className="footer-dark">
      <div className="container-lovac px-6 py-16">
        <div className="grid lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <img src={LOGO_URL} alt="Lovac" className="h-8 w-auto mb-6 invert-0" style={{ filter: "brightness(0) invert(1)" }} />
            <p className="text-sm text-on-dark-muted max-w-sm leading-relaxed">
              Un'agenzia di head hunting moderna, in un settore vecchio. Database verificato, AI e recruiter umani.
            </p>
          </div>

          <Col title="Navigazione">
            <FLink to="/metodo">Il nostro metodo</FLink>
            <FLink to="/casi-studio">Casi studio</FLink>
            <FLink to="/hiring-scan">Hiring Scan</FLink>
            <FLink to="/chi-siamo">Chi siamo</FLink>
            <FLink to="/contatti">Contattaci</FLink>
          </Col>

          <Col title="Per chi è">
            <FLink to="/per-chi-e/sales-commerciale">Sales · Commerciale</FLink>
            <FLink to="/per-chi-e/tech-digitale">Tech · IT</FLink>
            <FLink to="/per-chi-e/manager">Manager</FLink>
            <FLink to="/per-chi-e/finance-amministrazione">Finance · Amm.</FLink>
          </Col>

          <Col title="Legale">
            <FLink to="/privacy-policy">Privacy Policy</FLink>
            <FLink to="/cookie-policy">Cookie Policy</FLink>
            <FLink to="/informativa-candidati">Informativa candidati</FLink>
          </Col>
        </div>

        <div className="mt-16 pt-8 border-t border-lovac-dark grid md:grid-cols-2 gap-6">
          <div className="text-xs text-on-dark-muted leading-relaxed">
            <p className="text-on-dark font-medium mb-2">Venditore a Distanza Srl</p>
            <p>Via Zoe Fontana 220, 00131 Roma (RM)</p>
            <p>P.IVA 15627561002</p>
            <p className="mt-2">
              Accreditamento ai Servizi per il Lavoro, Regione Lazio<br />
              Determinazione n. G04261
            </p>
          </div>
          <div className="text-xs text-on-dark-muted md:text-right">
            <p>© {new Date().getFullYear()} Lovac</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
